/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {TDocumentDefinitions} from 'pdfmake/interfaces';

const genericPdfConfiguration = {
    pageSize: 'A4',
    pageMargins: [35, 55, 35, 60],
    pageOrientation: 'portrait',
    content: []
} as TDocumentDefinitions;

export default genericPdfConfiguration;
